
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/avis-legal/exempcio-de-garanties-i-responsabilitats",
      function () {
        return require("private-next-pages/corporatiu/avis-legal/exempcio-de-garanties-i-responsabilitats/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/avis-legal/exempcio-de-garanties-i-responsabilitats"])
      });
    }
  